import React from "react";
import {
  Button,
  Container,
  Typography,
  Box,
  styled,
  Fade,
  Stack,
  Divider,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { LogIn, UserPlus } from "lucide-react";
import RscLogo from "../../assests/logo/rscLogo";

const ErrorWrapper = styled(Box)(({ theme }) => ({
  minHeight: "100vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: theme.palette.background.paper,
}));

const ContentBox = styled(Box)(({ theme }) => ({
  backgroundColor: "#101010",
  borderRadius: "10px",
  border: "1px solid #ffffff85",
  textAlign: "left",
  padding: theme.spacing(6),
  boxShadow: theme.shadows[8],
  maxWidth: 480,
  width: "100%",
}));

const HeadingText = styled(Typography)(({ theme }) => ({
  fontSize: "2.5rem",
  fontWeight: 700,
  marginBottom: theme.spacing(2),
  textAlign: "left",
  ["@media (max-width:600px)"]: {
    fontSize: "2rem",
  },
}));

const LogoText = styled(Typography)(({ theme }) => ({
  color: "black",
  fontSize: "1.8rem",
  fontFamily: "Inter, sans-serif",
  fontWeight: "bolder",
  ["@media (max-width:600px)"]: {
    fontSize: "2rem",
  },
}));

const SubheadingText = styled(Typography)(({ theme }) => ({
  fontSize: "1.25rem",
  fontWeight: 400,
  color: theme.palette.text.secondary,
  marginBottom: theme.spacing(4),
  lineHeight: 1.6,
  ["@media (max-width:600px)"]: {
    fontSize: "1.125rem",
  },
}));

const StyledButton = styled(Button)(({ theme }) => ({
  padding: "12px 24px",
  borderRadius: theme.shape.borderRadius * 1.5,
  fontSize: "1rem",
  fontWeight: 600,
  textTransform: "none",
  display: "flex",
  gap: theme.spacing(1),
  width: "100%",
  justifyContent: "center",
  alignItems: "center",
}));

const LogoDisplaySection = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(1.5),
  backgroundColor: "white",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  width: "fit-content",
  borderRadius: "3px",
  margin: "20px 0px",
  gap: theme.spacing(2),
}));

function ErrorPage() {
  const navigate = useNavigate();

  return (
    <ErrorWrapper>
      <Container maxWidth="sm">
        <Fade in timeout={800}>
          <ContentBox>
            <LogoDisplaySection>
              <RscLogo color="black" />
              <LogoText color="black" variant="h1">
                RSC
              </LogoText>
            </LogoDisplaySection>
            <HeadingText variant="h1">Account Not Found</HeadingText>
            <SubheadingText>
              Sorry! We couldn't find an account with Provided Email ID. Please
              try logging in with different details or create a new account.
            </SubheadingText>

            <Divider sx={{ my: 4 }} />

            <Stack spacing={2.5}>
              <StyledButton
                variant="contained"
                onClick={() => navigate("/login")}
                sx={{
                  backgroundColor: "white",
                  "&:hover": {
                    backgroundColor: "primary.dark",
                  },
                }}
              >
                <LogIn size={20} />
                Login with Different Account
              </StyledButton>

              <StyledButton
                variant="outlined"
                onClick={() => navigate("/signup")}
                sx={{
                  borderColor: "primary.main",
                  color: "primary.main",
                  "&:hover": {
                    borderColor: "primary.light",
                    backgroundColor: "primary.main10",
                  },
                }}
              >
                <UserPlus size={20} />
                Signup
              </StyledButton>
            </Stack>
          </ContentBox>
        </Fade>
      </Container>
    </ErrorWrapper>
  );
}

export default ErrorPage;
